module.exports = __webpack_public_path__ + "c180abbb3fc1965cbd72a88ecef5cebc.svg";